import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Art } from './Art';
/**
 * A roll-on roll-off car carrier at the quay, stern ramp down, a little kei truck driving
 * aboard; sun low over the water. 240 × 140.
 */ export function CarrierShip({ title, className }) {
    return /*#__PURE__*/ _jsxs(Art, {
        viewBox: "0 0 240 140",
        title: title,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("circle", {
                className: "fo n",
                cx: "188",
                cy: "30",
                r: "15",
                opacity: ".9"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "sa thin",
                d: "m40 26 4 3 4-3M58 18l3 2.4 3-2.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fs n",
                d: "M0 104h240v36H0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "sa thin",
                d: "M8 116c6-3 12 3 18 0M60 124c6-3 12 3 18 0M150 118c6-3 12 3 18 0M196 128c6-3 12 3 18 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fh",
                d: "M0 98h52v8H0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "thin",
                d: "M8 98v8M24 98v8M40 98v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa",
                d: "M58 70h170c1.6 0 2.6 1.4 2.2 3l-7.6 28.4c-.6 2-2 3.2-4 3.2H74c-2 0-3.4-1-4.2-2.8L56 74c-.8-2 .2-4 2-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fb n",
                d: "m65.4 88 160.2-.2-1 4.2H67.2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fc",
                d: "M64 70V40c0-2 1.4-3.2 3.2-3.2H202c2 0 3.2 1.2 3.2 3.2v30"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "thin",
                d: "M64 52h141.2M78 44.6h112M78 60h112",
                opacity: ".7"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fp",
                d: "M182 36.8V22c0-1.6 1-2.6 2.6-2.6h22c1.6 0 2.6 1 2.6 2.6v14.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa n",
                d: "M187 25h17v5h-17Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fb",
                d: "M168 36.8V24h8v12.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fc",
                d: "m26 98 40-28 4 5.6L34 98Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "thin",
                d: "m34 92 4.6-3.2M42 86.4l4.6-3.2M50 80.8l4.6-3.2"
            }),
            /*#__PURE__*/ _jsxs("g", {
                transform: "rotate(-35 46 82)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        className: "fc",
                        d: "M33 82V72.4c0-1 .7-1.6 1.6-1.6h7.6c1 0 1.6.4 2 1.2l3.2 6.4v3.6Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "fa n",
                        d: "M40 72.6h1.6l2.6 4.8H40Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "fp",
                        d: "M47.4 82V75h12v7Z"
                    }),
                    /*#__PURE__*/ _jsx("circle", {
                        className: "fty",
                        cx: "37",
                        cy: "83",
                        r: "2.8"
                    }),
                    /*#__PURE__*/ _jsx("circle", {
                        className: "fty",
                        cx: "55",
                        cy: "83",
                        r: "2.8"
                    })
                ]
            })
        ]
    });
}
